/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const subscriptionCheckoutStatusSchema = z.enum(['active', 'requires_action'])

export type SubscriptionCheckoutStatusSchema = z.infer<typeof subscriptionCheckoutStatusSchema>
